// src/utils/dateUtils.js

// Returns YYYY-MM-DD string in the given IANA timezone (e.g. "America/New_York").
// Uses "en-CA" locale because it formats dates as YYYY-MM-DD natively.
export function toDateStrInTz(date, tz) {
  return new Intl.DateTimeFormat("en-CA", { timeZone: tz }).format(date);
}

// Returns true if `date` is before today in the business timezone.
export function isPastDayInTz(date, tz) {
  return toDateStrInTz(date, tz) < toDateStrInTz(new Date(), tz);
}

// Converts a booking's dateStr ("YYYY-MM-DD") + timeStr ("2:30 PM") in a given
// IANA timezone into the correct UTC ISO string to store in Firestore.
// Without this, storing toISOString() on a browser Date object can shift the
// calendar day by ±1 when the browser and the business are in different timezones.
export function bookingToUTC(dateStr, timeStr, tz) {
  const [time, mer] = timeStr.trim().split(" ");
  let [h, m] = time.split(":").map(Number);
  if (mer === "PM" && h !== 12) h += 12;
  if (mer === "AM" && h === 12) h = 0;
  const hh = String(h).padStart(2, "0");
  const mm = String(m).padStart(2, "0");
  // Treat the local time as if it were UTC to get a candidate ms value.
  const candidate = new Date(`${dateStr}T${hh}:${mm}:00Z`);
  // Find what the candidate UTC time looks like in the target timezone.
  // sv-SE locale gives "YYYY-MM-DD HH:MM:SS" which is safe to parse back as UTC.
  const localStr = candidate.toLocaleString("sv-SE", { timeZone: tz });
  const asUTC = new Date(localStr.replace(" ", "T") + "Z");
  // The offset (UTC − local) tells us how much to shift the candidate.
  return new Date(candidate.getTime() + (candidate.getTime() - asUTC.getTime())).toISOString();
}

export const MONTH_NAMES = [
  "January","February","March","April","May","June",
  "July","August","September","October","November","December",
];
export const DAY_NAMES_SHORT = ["Su","Mo","Tu","We","Th","Fr","Sa"];

export function getDaysInMonth(year, month) {
  return new Date(year, month + 1, 0).getDate();
}
export function getFirstDayOfMonth(year, month) {
  return new Date(year, month, 1).getDay();
}
export function isSameDay(a, b) {
  if (!a || !b) return false;
  return a.getFullYear() === b.getFullYear() &&
         a.getMonth()    === b.getMonth()    &&
         a.getDate()     === b.getDate();
}
export function isPastDay(date) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date < today;
}
export function formatDate(date) {
  if (!date) return "";
  return date.toLocaleDateString("en-US", {
    weekday: "long", month: "long", day: "numeric", year: "numeric",
  });
}
export function formatDateShort(date) {
  if (!date) return "";
  return date.toLocaleDateString("en-US", {
    month: "short", day: "numeric", year: "numeric",
  });
}
